export default __webpack_public_path__ + "static/media/Elenco Corsi DTE + Digital Pills.37d47a79.xlsx";